<template>
  <div class="TooltipContentKeyboardShortcut">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.TooltipContentKeyboardShortcut {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
